import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Loading } from './loading';

@Component({
  // selector: 'app-root',
  selector: 'body',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {
  
  constructor(private router: Router) { }
  isLoading = 0;
  ngOnInit() {
    setInterval(() => {
      this.isLoading = Number(sessionStorage.getItem('isLoading'));
    }, 100);
    
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/app.component.ts